<template>
  <div :class="$style.container">
    <BaseInput
      v-model="text"
      :placeholder="placeholder"
      multiline rows="2"
      :class="$style.input"
      @keydown.enter.exact.prevent
      @keyup.enter.exact="onSubmit"
    />
    <div :class="$style.buttons">
      <BaseIcon
        custom name="close"
        :class="$style.closeBtn"
        @click="$emit('close')"
      />
      <BaseIcon
        custom name="locationArrow"
        :class="$style.sendBtn"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'social-comment-input',
  props: {
    postId: {
      type: Number,
      required: true
    },
    replyTo: Object,
    editedComment: Object
  },
  data () {
    return {
      text: ''
    }
  },
  created () {
    if (this.editedComment) {
      this.text = this.editedComment.text
    }
  },
  computed: {
    placeholder () {
      if (this.replyTo) {
        return this.$t('socialPost.placeholderReply', { name: this.replyTo.userObj.displayName })
      }
      return this.$t('socialPost.placeholderComment')
    }
  },
  methods: {
    ...mapActions({
      send: 'entities/socialComments/sendComment',
      edit: 'entities/socialComments/editComment'
    }),
    async onSubmit () {
      if (!this.text) return
      const data = {
        text: this.text
      }
      if (this.replyTo) {
        data.replyTo = this.replyTo.id
      }
      if (!this.editedComment) {
        await this.send({
          postId: this.postId,
          data
        })
      } else {
        await this.edit({
          id: this.editedComment.id,
          text: this.text
        })
      }
      this.$emit('close')
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
}
.input {
  flex-grow: 1;
}
.buttons {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-basis: 60px;
  padding-bottom: 28px;
}
.closeBtn {
  font-size: 12px;
  color: $text-dark;
  cursor: pointer;
}
.sendBtn {
  transform: rotate(135deg);
  color: #00b764;
  font-size: 20px;
  cursor: pointer;
}
</style>
